import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { DsButtonKind } from '@frontend/ui/button';
import { Store, createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { editBetStateSelector } from '../../../types/selectors';
import { EditBetActions } from '../../actions';

export const isNewPicksContainerVisibleSelector = createSelector(editBetStateSelector, (state) => state.addPicksState.isVisible);

@Component({
    selector: 'bs-betslip-edit-mybet-add-selection',
    templateUrl: './edit-bet-add-selection.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-add-selection.component.scss'],
    standalone: false,
})
export class EditBetAddSelectionComponent implements OnInit {
    isNewPicksContainerVisible$: Observable<boolean>;

    private isNewPicksContainerVisible: boolean;
    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'sportingbet-br': 'tertiary', 'betboo-br': 'tertiary' };
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        public siteCore: Sitecore,
        private changeDetectorRef: ChangeDetectorRef,
        private store: Store<IBetslipRootState>,
    ) {
        this.isNewPicksContainerVisible$ = this.store.select(isNewPicksContainerVisibleSelector);
    }

    ngOnInit(): void {
        this.isNewPicksContainerVisible$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((next) => {
            this.isNewPicksContainerVisible = next;
            this.changeDetectorRef.detectChanges();
        });
    }

    get isButtonDisabled(): boolean {
        return this.isNewPicksContainerVisible;
    }

    addSelection(): void {
        if (!this.isNewPicksContainerVisible) {
            this.store.dispatch(EditBetActions.switchToAddSelectionMode());
        }
    }
}
